import React from 'react';
import { I18n } from '@aws-amplify/core';
import { InfoCircleOutlined } from '@ant-design/icons';
import * as S from './styles';

interface InfoTooltipProps {
	message: string;
}

export function InfoTooltip({ message }: Readonly<InfoTooltipProps>): JSX.Element {
	return (
		<S.CustomTooltip
			showArrow
			placement="top"
			title={I18n.get(message)}
			getPopupContainer={(triggerNode) => triggerNode}
		>
			<InfoCircleOutlined />
		</S.CustomTooltip>
	);
}
